<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Sede Sucursal </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="asignarsede()">
              <v-icon small class="mr-2">
                mdi-plus
              </v-icon>
              Asignar Otra Sede
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.sede`]="{ item }">
          <span> {{ item.sede.nombre }} </span>
        </template>

        <template v-slot:[`item.sucursal`]="{ item }">
          <span> [{{ item.sucursal.numero_sucursal }}] {{ item.sucursal.direccion }} </span>
        </template>

        <template v-slot:[`item.punto_venta`]="{ item }">
          <span v-if="item.punto_venta.nombre">
            [{{ item.punto_venta.codigo_punto_venta }}] {{ item.punto_venta.nombre }} {{ item.punto_venta.descripcion }}
          </span>
        </template>

        <template v-slot:[`item.xnit`]="{ item }">
          <span v-if="item.xnit"> {{ item.xnit.tipo_facturacion }} </span>
        </template>

        <template v-slot:[`item.xnitnro`]="{ item }">
          <span v-if="item.xnit"> {{ item.xnit.nit }} </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="red" dark v-bind="attrs" v-on="on">
                <v-icon small @click="preeliminar(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Quitar Sede Sucursal</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="orange" dark v-bind="attrs" v-on="on">
                <v-icon small @click="editarasignacion(item)">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>Editar Sede Sucursal</span>
          </v-tooltip>

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Punto de venta</span>
          </v-tooltip> -->

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="!item.iselectronica" small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon
                  small
                  @click="
                    $router.push(
                      '/pventas?idsucursal=' + item.sucursal_id + '&numsucursal=' + item.sucursal.numero_sucursal,
                    )
                  "
                >
                  mdi-briefcase-download
                </v-icon>
              </v-btn>
            </template>
            <span>Agregar Punto de venta</span>
          </v-tooltip> -->
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="asignarsede(item)">
                  mdi-map-marker-right
                </v-icon>
              </v-btn>
            </template>
            <span>Asignar a Sede</span>
          </v-tooltip> -->

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="asignacionsedes(item)">
                  mdi-nature
                </v-icon>
              </v-btn>
            </template>
            <span>Sedes sucursal</span>
          </v-tooltip> -->
        </template>
      </v-data-table>
    </template>

    <SucursalesAM ref="unidadesam" v-on:newregsucursal="newregsucursal" />
    <SucursalesDEL ref="unidadesdel" />
    <Asignarsede ref="asignarsede" v-on:newregasignar="newregasignar" />
  </div>
</template>

<script>
  import SucursalesAM from '@/views/Sucursales/Sucursalesam.vue';
  import SucursalesDEL from '@/views/Sucursales/Sucursalesdel.vue';
  import Asignarsede from '@/views/Sucursales/Asignarsede.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        { text: 'Sede', value: 'sede' },
        { text: 'Sucursal', value: 'sucursal' },
        { text: 'Punto venta', value: 'punto_venta' },
        { text: 'NIT', value: 'sucursal.nro_nit' },
        { text: 'TIPO', value: 'sucursal.tipo_facturacion' },
        { text: 'Opciones', value: 'actions', sortable: false, width: 120 },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { SucursalesAM, SucursalesDEL, Asignarsede },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let sucursalId = this.$route.query.sucursalId;
        let vue = this;
        //let peticiones = [];
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sucursalId=${sucursalId}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.reverse();
            window.console.log('>>>', data);
            data.map((x) => {
              x.iselectronica = false;
            });
            vue.desserts = data;
            vue.loading = false;
            /*vue.desserts.forEach((x) => {
              const promise = axios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${x.sede_id}`);
              peticiones.push(promise);
            });*/

            /*Promise.all(peticiones)
              .then(function(values) {
                values.forEach((x) => {
                  let idsuc = x.data.id;
                  let s = vue.desserts.find((ss) => ss.sede_id == idsuc);
                  if (s) {
                    s.xnit = x.data;
                  }
                  if (s && x.data.tipo_facturacion.includes('ELECTR')) {
                    s.iselectronica = true;
                  }
                  //window.console.log(s, x.data);
                  vue.loading = false;
                });
              })
              .catch((e) => {
                window.console.error(e);
                vue.loading = false;
              });*/

            //window.console.log(response.data);
            //vue.loading = false;
          })
          .catch(function(error) {
            vue.loading = false;
            window.console.log(error);
          });
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.$refs.unidadesam.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      asignarsede() {
        let sucursalId = this.$route.query.sucursalId;
        let item = {
          id: parseInt(sucursalId),
        };
        this.$refs.asignarsede.openmodal(item, false);
      },
      editarasignacion(item) {
        let xitem = window.Object.assign({}, item);
        xitem.idsedesucursal = item.id;
        xitem.id = item.sucursal.id;
        this.$refs.asignarsede.openmodal(xitem, true);
      },

      asignacionsedes(item) {
        let url = `/asignacionsede?idsucursal=${item.id}`;
        this.$router.push(url);
      },

      newregasignar() {
        this.initialize();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      newregsucursal(item) {
        window.console.log('newregsucursal', item);
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      preeliminar(item) {
        window.console.log(item);
        let vue = this;
        let opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para quitar la relacion sede sucursal.',
          okText: 'Eliminar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar eliminacion',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.quitarsedesucursal(item, dialog);
          })
          .catch(function() {});
      },
      quitarsedesucursal(item, dialog) {
        window.console.log(item);
        let vue = this;
        var config = {
          method: 'delete',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales/${item.id}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('quitarsedesucursal::', data);
            dialog.close();
            vue.initialize();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
          });
      },
    },
  };
</script>
